import styles from "./TransparentButton.module.scss";

const ShowOnHover = (props) => 
  <span {...props} className={styles.ShowOnHover}>{props.children}</span>;

export default ShowOnHover;
